/*
 * Voraussichtliches Lieferdatum (Design BF26) - Gegenstueck zu snippets/ll-delivery-date.liquid, dort stehen die Regeln.
 *
 * Liquid rechnet das Datum vor. Shopify speichert Seiten aber zwischen - deshalb hier beim Laden mit dem heutigen Datum
 * (Zeitzone Europe/Berlin, unabhaengig vom Standort des Besuchers) nachrechnen und beim Variantenwechsel neu rechnen.
 * Datenquelle ist wie bei allen Ampel-Anzeigen das [data-traffic-json] des Variant Pickers (inkl. Markt-Aufschlag).
 */
const berlinToday = () => {
  const [year, month, day] = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date()).split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

const isoDate = (date) => date.toISOString().slice(0, 10);

class DeliveryDate extends HTMLElement {
  connectedCallback() {
    this.onVariantChange = (event) => {
      // getAttribute statt .id: Das Produktformular enthaelt <input name="id">, dadurch liefert form.id das Eingabefeld.
      if (event.target?.getAttribute?.("id") === this.getAttribute("form") && event.detail?.variant) {
        this.render(this.statusFor(event.detail.variant.id));
      }
    };
    document.addEventListener("variant:change", this.onVariantChange);

    const selected = document.forms[this.getAttribute("form")]?.querySelector("[name='id']")?.value;
    if (selected) {
      this.render(this.statusFor(selected));
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this.onVariantChange);
  }

  statusFor(variantId) {
    try {
      const json = this.closest("variant-picker-tm")?.querySelector("[data-traffic-json]");
      const entry = JSON.parse(json.textContent).variants.find((variant) => variant.id === String(variantId));
      return entry ? { status: entry.status || "", quantity: Number(entry.inventory_quantity) || 0 } : null;
    } catch {
      return null;
    }
  }

  isWorkday(date) {
    const weekday = date.getUTCDay();
    return weekday !== 0 && weekday !== 6 && !(this.dataset.holidays || ";").includes(`;${isoDate(date)};`);
  }

  // Der count-te Werktag nach heute
  workdayAfterToday(count) {
    const date = berlinToday();
    let remaining = count;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (this.isWorkday(date)) {
        remaining -= 1;
      }
    }
    return date;
  }

  // "48 Stunden" nur, wenn heute, morgen und uebermorgen Werktage sind (Mo-Mi ohne freie Tage)
  fastPossible() {
    const date = berlinToday();
    for (let offset = 0; offset <= 2; offset += 1) {
      if (!this.isWorkday(date)) {
        return false;
      }
      date.setUTCDate(date.getUTCDate() + 1);
    }
    return true;
  }

  render(data) {
    if (!data) {
      return;
    }
    const status = data.status.trim();
    const visible = /^auf lager/i.test(status) && data.quantity > 0;
    this.hidden = !visible;
    if (!visible) {
      return;
    }

    const text = this.querySelector("[data-ll-delivery-text]");
    const numbers = status.match(/\d+/g);
    const days = numbers ? Number(numbers[numbers.length - 1]) : 0;
    let html;

    if (days > 0 && days <= 2 && this.fastPossible()) {
      html = this.dataset.fast;
    } else if (days > 0 && this.dataset.mode === "date") {
      // Datum stillgelegt (Alex 17.10.2026) - nur aktiv mit data-mode="date"; Standard zeigt die ERP-Spanne (else-Zweig)
      // Bis 2 Tage: 2. Werktag nach heute. Sonst Starttag (naechster Werktag) + N Werktage.
      const date = this.workdayAfterToday(days <= 2 ? 2 : days + 1);
      const weekdays = (this.dataset.weekdays || "").split(",");
      const label = `${weekdays[(date.getUTCDay() + 6) % 7]} ${String(date.getUTCDate()).padStart(2, "0")}.${String(date.getUTCMonth() + 1).padStart(2, "0")}.`;
      html = (this.dataset.until || "").replace("%date%", label);
    } else {
      text.textContent = status.replace("Auf Lager,", "Lieferzeit").replace(" - ", "-");
      return;
    }
    if (text.innerHTML !== html) {
      text.innerHTML = html;
    }
  }
}

if (!customElements.get("ll-delivery-date")) {
  customElements.define("ll-delivery-date", DeliveryDate);
}
